<template>
  <div>
    <ListPage
      title="Inventory"
      :headers="headers"
      :items="data.items"
      :view="['table']"
    >
      <template #charts>
        <v-col cols="12" sm="6">
          <v-card class="mx-auto text-center" :height="300">
            <v-card-text>
              <CountByInterestCategoryListChart
                :value="stats.countByCategory"
                :height="300"
              />
            </v-card-text>

            <v-card-text>
              <div class="text-h5 font-weight-thin">Categories Coverage</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card :height="300">
            <CountByInterestCategoryListChart
              :value="stats.countByCategory"
              :height="300"
            />
          </v-card>
        </v-col>
      </template>

      <template #actions>
        <v-btn
          variant="text"
          class=""
          color="primary"
          @click="() => (newDialog = !newDialog)"
        >
          <template #prepend>
            <v-icon>mdi-plus</v-icon>
          </template>
          Submit New
        </v-btn>
      </template>
      <template #card="{ item }">
        <InventoryItemCardItem
          :value="item"
          @on-details="onDetails"
          @on-share="onShare"
        />
      </template>

      <template #row="{ item, headers }">
        <InventoryItemTableItem
          @on-details="onDetails"
          :value="item"
          :headers="headers"
        />
      </template>
    </ListPage>
    <InventoryItemCreateDialog v-model="newDialog" @create="create" />
  </div>
</template>

<script>
import ListPage from "../../components/organisms/layout/ListPage.vue";
import InventoryItemCreateDialog from "../../components/organisms/inventoryItem/InventoryItemCreateDialog.vue";
import InventoryItemCardItem from "../../components/organisms/inventoryItem/InventoryItemCardItem.vue";
import InventoryItemTableItem from "../../components/organisms/inventoryItem/InventoryItemTableItem.vue";
import { InventoryAPIInstance } from "../../api";
import CountByInterestCategoryListChart from "../../components/organisms/inventoryItem/Charts/CountByInterestCategoryListChart.vue";

export default {
  name: "InventoryList",
  components: {
    InventoryItemCardItem,
    InventoryItemTableItem,
    ListPage,
    InventoryItemCreateDialog,
    CountByInterestCategoryListChart,
  },
  data() {
    return {
      newDialog: false,
      headers: [
        { title: "ID", key: "id" },
        { title: "Status", key: "Status" },
        { title: "Name", key: "name" },
        { title: "Website", key: "Website" },
        { title: "Description", key: "description" },
        { title: "Created", key: "created_at" },
      ],
      data: {
        items: [],
        pagination: {
          page: 1,
          pageSize: 10,
        },
      },
      stats: {
        countByCategory: [],
      },
    };
  },
  computed: {},

  created() {
    this.getList();
    this.getStats();
  },
  methods: {
    async getStats() {
      const [countByCategory] = await Promise.all([
        InventoryAPIInstance.Stats.countByInterestCategories(),
      ]);

      this.stats.countByCategory = countByCategory;
    },
    async getList() {
      const { items, pagination } = await InventoryAPIInstance.list(
        this.data.pagination
      );

      this.data.items = items;
      this.data.pagination = pagination;
    },
    async create(inventoryItem) {
      await InventoryAPIInstance.create(inventoryItem, {
        toast: {
          message: "Inventory Item Created",
          color: "success",
        },
      });

      this.newDialog = false;

      this.getList();
      this.getStats();
    },
    onDetails(inventoryItem) {
      this.$router.push(`/inventory/${inventoryItem.id}`, {
        params: { id: inventoryItem.id },
      });
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped>

</style>